import { NgModule } from '@angular/core';
import { CountdownTimerComponent } from './countdown-timer.component';

@NgModule({
  declarations: [
    CountdownTimerComponent
  ],
  exports: [
    CountdownTimerComponent
  ]
})
export class CountdownTimerModule {}
